import * as Sentry from '@sentry/browser'

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn:
            'https://c76ee5dfe8a74cce8426f58d252304d8@o195685.ingest.sentry.io/1301368',
    })
}
